import store from '@/store';
import axios from 'axios';
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { Mutations, Endpoints } from '@/ts/store/Constants';
import AttachmentData from '@/ts/AttachmentData';
import ErrorResponse from '@/ts/ErrorResponse';


@Module({name: 'Attachments', namespaced: true})
export default class Attachments extends VuexModule {
    public attachments: AttachmentData[] = [];
    public attachmentMap: { [index: string]: number } = {};

    @Mutation
    public RESET_ATTACHMENTS_STORE_STATE(): void {
        this.attachments   = [];
        this.attachmentMap = {};
    }

    get getAttachment() {
        return (guid: string) => this.attachments[this.attachmentMap[guid]];
    }

    @Action
    public UPLOAD_ATTACHMENT(file: File) {
        const headers = {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        };

        const url = Endpoints.Attachments.ATTACHMENT;

        const requestPayload = new FormData();
        requestPayload.append('attachment', file);
        requestPayload.append('conversationId', store.getters['Messages/activeConversation'].id);

        switch (file.type) {
            case 'application/pdf':
                break;

            default:
                break;
        }

        axios.post(url, requestPayload, headers)
            .then((response) => {
            })
            .catch((error) => {
                if (error.response) {
                    const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                    store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                } else {
                    console.log(error);
                }
            });
    }
}
